// Turkish case suffixes for proper nouns and numbers, attached with an apostrophe ("Burak Taş'a", "100'ü")

const VOWELS = "aeıioöuü";
const BACK_VOWELS = "aıou";

// Spoken last word of a number decides the suffix (100 -> "yüz" -> "100'ü")
const UNITS = ["sıfır", "bir", "iki", "üç", "dört", "beş", "altı", "yedi", "sekiz", "dokuz"];
const TENS = ["", "on", "yirmi", "otuz", "kırk", "elli", "altmış", "yetmiş", "seksen", "doksan"];

const spokenLastWord = (number) => {
  const n = Math.abs(Math.trunc(Number(number)));
  if (n === 0) return UNITS[0];
  if (n % 10) return UNITS[n % 10];
  if (n % 100) return TENS[(n % 100) / 10];
  if (n % 1000) return "yüz";
  if (n % 1000000) return "bin";
  if (n % 1000000000) return "milyon";
  return "milyar";
};

const sound = (word) => {
  const lower = (word || "").toLocaleLowerCase("tr");
  const letters = [...lower].filter((ch) => /\p{L}/u.test(ch));
  const vowels = letters.filter((ch) => VOWELS.includes(ch));
  // No vowel at all (e.g. an abbreviation): fall back to a front vowel
  const lastVowel = vowels.length ? vowels[vowels.length - 1] : "e";
  const endsWithVowel = letters.length > 0 && VOWELS.includes(letters[letters.length - 1]);
  return { lastVowel, endsWithVowel };
};

const twoWay = (vowel) => (BACK_VOWELS.includes(vowel) ? "a" : "e");

const fourWay = (vowel) => {
  if ("aı".includes(vowel)) return "ı";
  if ("ei".includes(vowel)) return "i";
  if ("ou".includes(vowel)) return "u";
  return "ü";
};

const attach = (text, suffix) => `${text}'${suffix}`;

export const dative = (name) => {
  const text = (name || "").trim();
  if (!text) return "";
  const { lastVowel, endsWithVowel } = sound(text);
  return attach(text, `${endsWithVowel ? "y" : ""}${twoWay(lastVowel)}`);
};

export const genitive = (name) => {
  const text = (name || "").trim();
  if (!text) return "";
  const { lastVowel, endsWithVowel } = sound(text);
  return attach(text, `${endsWithVowel ? "n" : ""}${fourWay(lastVowel)}n`);
};

export const possessive = (number) => {
  const { lastVowel, endsWithVowel } = sound(spokenLastWord(number));
  return attach(String(number), `${endsWithVowel ? "s" : ""}${fourWay(lastVowel)}`);
};
